// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1pXW7","alert":"SettungsInbox_alert__3evMQ"};